import React, { useEffect, useState } from 'react';
import { Switch, FormControlLabel } from '@material-ui/core';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import * as actions from '../../common/store/descarte.action';
import { useDispatch } from 'react-redux';
import DescarteApi from '../../descarte.api';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../../helpers/intlMessage';
import { injectIntl } from 'react-intl';

function ModalDescarte( props){

const [modalAberto, setModalAberto] = useState(false);
const [isPrint, setIsPrint] = useState(false);
const [pesoG, setPesoG] = useState();
const [pesoKG, setPesoKG] = useState();
const [motivo, setMotivo] = useState('');
const [selectMotivos, setSelectMotivos] = useState([]);
const [observacao, setObservacao] = useState('');
const backdrop = !props.backdrop ? false : props.backdrop;
const keyboard = props.keyboard === undefined ? true : props.keyboard;

const dispatch = useDispatch();
const { messages } = props.intl;

function resetInputs(){
  setIsPrint(false);
  setPesoG();
  setPesoKG();
  setMotivo('');
  setObservacao('');
}

useEffect(()=>{
  DescarteApi.listarMotivosDescarte().then((res)=>{
    setSelectMotivos(res.data);
  }).catch((err)=>{
    console.log(err);
  });
},[])

 useEffect(()=>{
  resetInputs();
  setModalAberto(props.showModalDescarte);
  dispatch(commonActions.showModal(props.showModalDescarte));
 }, [props.showModalDescarte]);

 useEffect(()=>{
  changePesoG(props.totalPeso);
 }, [props.totalPeso]);

function changePesoG(el) {
  if(!el){
    setPesoKG(el);
    setPesoG(el);
    dispatch(actions.peso(el));
    dispatch(actions.motivo(el));
    return;
  }
  setPesoG(el);
  dispatch(actions.peso(el));
  dispatch(actions.motivo(el));
  setPesoKG(Number(el)/1000);
}
function changePesoKG(el) {
  if(!el){
    setPesoKG(el);
    setPesoG(el);
    dispatch(actions.peso(el));
    return;
  }
  setPesoKG(el);
  if(Number(el) === 0){
    setPesoG(0);
    dispatch(actions.peso(0));
  }else{
    setPesoG(Number(el)*1000);
    dispatch(actions.peso(Number(el)*1000));
  }
}
function toggle() {
  setModalAberto(!modalAberto);
  dispatch(commonActions.showModal(!modalAberto));
  props.onModal(!modalAberto);
}
function changeMotivo(el) {
  setMotivo(el);
  dispatch(actions.motivo(el));
}
function changePrint(el) {
  setIsPrint(el);
  dispatch(actions.imprimir(el));
}
function changeObs(el) {
  if(el.length>200){
    return;
  }
  setObservacao(el);
  dispatch(actions.observacao(el));
}

function textLength(observacao, max = 200){
  // const carac = 200 - observacao.length;
  // let msn = `${carac} Carácteres restantes`;

  // if(carac === 1){
  //   msn = `${carac} Caracter restante`;
  // }else if (carac === 0){
  //   msn = `Máximo de caracteres atingido `;
  // }

  if (!observacao) {
    return;
  }
  const carac = max - observacao.length;
  let msn = messages['message.remaining.more'].replace(`{char}`, carac);
  if (carac === 1) {
    msn = messages['message.remaining.only'].replace(`{char}`, carac);
  } else if (carac === 0) {
    msn = messages['message.maxlength'];
  }

  return msn;
}

 return (
   <React.Fragment>
     <div>
       <Modal
         className="modal-confirm"
         backdrop={backdrop}
         keyboard={keyboard}
         centered
         isOpen={modalAberto}
         toggle={toggle}
       >
         <ModalHeader toggle={!props.close ? toggle : props.close}>
           <IntlMessage id = "dashboards.disposalMaterials.modal.disposalInformation"/> {props.tipo}
         </ModalHeader>
         <ModalBody>
           <Row>
             <Col>
               <FormGroup className={`confirmar-primary`}>
                 <Label><IntlMessage id = "dashboards.disposalMaterials.modal.weightG"/></Label>
                 <Input
                   type="number"
                   value={pesoG}
                   onChange={(e) => changePesoG(e.target.value)}
                 />
               </FormGroup>
             </Col>
             <Col>
               <FormGroup className={`confirmar-primary`}>
                 <Label><IntlMessage id = "dashboards.disposalMaterials.modal.weightKG"/></Label>
                 <Input
                   type="number"
                   value={pesoKG}
                   onChange={(e) => changePesoKG(e.target.value)}
                 />
               </FormGroup>
             </Col>
           </Row>
           <Row>
             <Col>
               <FormGroup className={`confirmar-primary`}>
                 <Label><IntlMessage id = "dashboards.disposalMaterials.modal.observation"/></Label>
                 <Input
                   type="textarea"
                   value={observacao}
                   onChange={(e) => changeObs(e.target.value)}
                 />
                 <div className="texto-observacao">{textLength()}</div>
               </FormGroup>
             </Col>
           </Row>

           <Row>
             <Col>
               <FormGroup className={`confirmar-primary`}>
                 <SelectComponent
                   options={selectMotivos}
                   placeholder={messages["dashboards.disposalMaterials.modal.reasonDiscard"]}
                   defaultValue={motivo}
                   onChange={(e) => changeMotivo(e)}
                 />
               </FormGroup>
             </Col>
           </Row>
           <Row>
             <Col>
               <FormControlLabel
                 control={
                   <Switch
                     checked={isPrint}
                     onChange={(e) => changePrint(e.target.checked)}
                     name="descarte-imprimir"
                     color="primary"
                   />
                 }
                 label={<IntlMessage id = "dashboards.disposalMaterials.modal.wantPrint"/>}
               />
             </Col>
           </Row>
         </ModalBody>
         <ModalFooter>
           <Button
             onClick={!props.cancelar ? toggle : props.cancelar}
             className={`button-cancel`}
             color="secondary"
           >
             <IntlMessage id = "dashboards.disposalMaterials.modal.cancel"/>
           </Button>
           <Button
             className={`button-confirm`}
             onClick={props.confirmar}
             disabled={
               (!pesoG && pesoG !== 0) ||
               (!pesoKG && pesoKG !== 0) ||
               !observacao || !motivo
             }
             color="primary"
           >
            <IntlMessage id = "dashboards.disposalMaterials.modal.confirm"/>
           </Button>
         </ModalFooter>
       </Modal>
     </div>
   </React.Fragment>
 );
}

export default injectIntl(ModalDescarte);


// WEBPACK FOOTER //
// ./src/pages/descarte/modais/descarte/index.js